import React from 'react';

import { ConnectAccountOnboarding } from '@stripe/react-connect-js';

export interface AccountOnboardingProps {
  /** O prestador saiu do fluxo (concluiu ou fechou). Sempre invalidar a conta ao receber isto. */
  onExit: () => void;
  /** Sem efeito na web — o componente é inline, sem barra de navegação própria. */
  title?: string;
}

/**
 * Cadastro (`account-onboarding`, T4.4): confirma os dados pré-preenchidos
 * e aceita o contrato do Stripe — etapa 6 do assistente
 * (`ActivationStripeStep`, `payment-activation-screen.tsx`) e "Resolver
 * pendência" (T4.5). Precisa estar dentro de um `StripeConnectProvider`.
 */
export function AccountOnboarding({ onExit }: AccountOnboardingProps) {
  return <ConnectAccountOnboarding onExit={onExit} />;
}
